import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import En_Translations from "../locales/en/translation.json";
import Ar_Translations from "../locales/ar/translation.json";

const resources = {
  en: {
    translation: En_Translations,
  },
  ar: {
    translation: Ar_Translations,
  },
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    supportedLngs: ["en", "ar"],
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["path", "localStorage", "navigator"],
      caches: ["localStorage"],
    },
    react: {
      transSupportBasicHtmlNodes: true
    }
  });

export default i18n;
